import React from 'react';
import { ListPageScaffold } from '../../components/common/list-page';
import ProductMovementHistory from '../../components/reports/ProductMovementHistory/ProductMovementHistory';

const ProductMovementHistoryPage: React.FC = () => {
  return (
    <ListPageScaffold>
      <ProductMovementHistory />
    </ListPageScaffold>
  );
};

export default ProductMovementHistoryPage;
